import styled from "@emotion/styled";
import { CryptoIcon } from "src/Common/components";
import { get } from "lodash";
import cryptoIconsBySlugMap from "../../../../Common/utils/cryptosAssets/cryptoIconsBySlugMap.json";
import { CryptoIconsBySlugMap } from "src/Common/utils/cryptosAssets/types";

interface Props {
  symbol?: string;
  slug?: string;
  displayName?: string;
  name?: string;
  onClick?: () => void;
  containerProps?: any;
  selected?: boolean; // TODO: call this prop active or do a generic component
  highlighted?: boolean;
}

export const CryptoItem = ({
  symbol,
  slug,
  selected,
  onClick,
  containerProps,
  highlighted,
  name,
}: Props) => {
  return (
    <CryptoContainer
      {...containerProps}
      onClick={(e) => {
        return e.altKey
          ? slug &&
              window.open(
                `https://coinmarketcap.com/currencies/${slug}/markets`,
                "_blank",
                "noopener,noreferrer"
              )
          : onClick;
      }}
    >
      {highlighted ? (
        <CryptoIconWithBorder>
          <CryptoIcon
            symbol={symbol}
            slug={slug}
            style={{ height: "1.6rem" }}
          />
        </CryptoIconWithBorder>
      ) : (
        <CryptoIcon symbol={symbol} slug={slug} style={{ height: "1.6rem" }} />
      )}
      <Body>
        <Symbol selected={selected || false}>{symbol}</Symbol>
        <Name>
          {name ??
            get(cryptoIconsBySlugMap as CryptoIconsBySlugMap, `${slug}`)
              ?.name ??
            symbol}
        </Name>
      </Body>
    </CryptoContainer>
  );
};

const CryptoContainer = styled.div({
  minWidth: "7rem",
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
});

const CryptoIconWithBorder = styled.div(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: `2px dotted ${theme.palette.primary.main}`,
  borderRadius: "50%",
  "& > img": {
    transform: "scale(0.8)",
  },
}));

const Body = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: "0 0.5rem",
});

const Symbol = styled.div(({ theme, selected }: any) => ({
  // TODO: Fixme
  color: selected
    ? theme.palette.primary.main
    : theme.palette.primary.contrastText,
  fontWeight: 600,
  fontSize: "0.9rem",
}));

const Name = styled.div(({ theme }) => ({
  fontSize: "0.7rem",
  color: theme.palette.grey[400],
}));
